import React from 'react';
import css from 'styled-jsx/css';
import Container from '~/components/Container';
import SEOTextACworks from '~/components/SEOTextACworks';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
import { SERVICE_TYPES } from '~/utils/constants';
import I18nLink from '~/components/I18nLink';

class Discover extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <div>
        <Container className={containerHeader}>
          <div className="discover-container">
            <div className="title-discover">
              {t('ai_landing_page_discover_title')}
            </div>
            <div className="content-discover">
              <I18nLink host={Config.getSiteURL(SERVICE_TYPES.PHOTO_AC)}>
                <a target="_blank" className="photo-container">
                  <div className="img-discover-container">
                    <img
                      className="img-discover"
                      src={`${Config.staticPrefix}/static/images/ai-landing-page/discover_photo.png`}
                      alt="discover-img"
                    />
                  </div>
                  <div className="text-title">
                    {t('ai_landing_page_discover_photo')}
                  </div>
                </a>
              </I18nLink>
              <I18nLink host={Config.getSiteURL(SERVICE_TYPES.ILLUST_AC)}>
                <a target="_blank" className="ill-container">
                  <div className="img-discover-container">
                    <img
                      className="img-discover"
                      src={`${Config.staticPrefix}/static/images/ai-landing-page/discover_illust.png`}
                      alt="discover-img"
                    />
                  </div>
                  <div className="text-title">
                    {t('ai_landing_page_discover_ill')}
                  </div>
                </a>
              </I18nLink>
              <I18nLink host={Config.getSiteURL(SERVICE_TYPES.SILHOUETTE_AC)}>
                <a target="_blank" className="sil-container">
                  <div className="img-discover-container">
                    <img
                      className="img-discover"
                      src={`${Config.staticPrefix}/static/images/ai-landing-page/discover_silhouttes.png`}
                      alt="discover-img"
                    />
                  </div>
                  <div className="text-title">
                    {t('ai_landing_page_discover_sil')}
                  </div>
                </a>
              </I18nLink>
            </div>
            <style jsx>
              {`
                .discover-container {
                  padding-bottom: 60px;
                }

                .title-discover {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  margin-top: 48px;
                  height: 58px;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 26px;
                }
                .content-discover {
                  display: flex;
                  justify-content: space-between;
                  gap: 8px;
                }
                .img-discover {
                  width: 100%;
                }
                .text-title {
                  font-style: normal;
                  font-weight: 600;
                  font-size: 20px;
                  margin-top: 24px;
                  color: ${themeVariables.colors.bodyText};
                }
                @media (max-width: ${themeVariables.breakpoints.tabletL
                    .maxWidth}px) {
                  .title-discover {
                    font-size: 22px;
                  }
                }
                @media (max-width: ${themeVariables.breakpoints.mobile
                    .maxWidth}px) {
                  .text-title {
                    font-size: 22px;
                  }
                  .title-discover {
                    font-size: 20px;
                    margin-top: 24px;
                    margin-bottom: 12px;
                  }
                  .text-title {
                    font-size: 16px;
                  }
                }
              `}
            </style>
          </div>
          {containerStylesHeader}
        </Container>
        <SEOTextACworks />
      </div>
    );
  }
}
const {
  className: containerHeader,
  styles: containerStylesHeader,
} = css.resolve`
  margin-top: 60px;
  background: #f8f9fa;
`;
export default Discover;
